"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OAuthModals = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./users/constants");

var _constants2 = require("./constants");

var _constants3 = require("./roles/constants");

var _constants4 = require("./clients/constants");

var _constants5 = require("./apis/constants");

var _constants6 = require("./scopes/constants");

var _constants7 = require("./tenants/constants");

var _createUser = require("./users/components/create-user");

var _viewUser = require("./users/components/view-user");

var _changePassword = require("./users/components/change-password");

var _createRole = require("./roles/components/create-role");

var _createClient = require("./clients/components/create-client");

var _createApi = require("./apis/components/create-api");

var _createScope = require("./scopes/components/create-scope");

var _createTenant = require("./tenants/components/create-tenant");

var _confirmModal = require("./common/components/confirm-modal");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var OAuthModals = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(OAuthModals, _PureComponent);

  var _super = _createSuper(OAuthModals);

  function OAuthModals() {
    (0, _classCallCheck2.default)(this, OAuthModals);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(OAuthModals, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeModal = _this$props.activeModal,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["activeModal"]);

      switch (activeModal) {
        case _constants.CREATE_USER_MODAL_KEY:
          return /*#__PURE__*/_react.default.createElement(_createUser.CreateUser, rest);

        case _constants.VIEW_USER_MODAL_KEY:
          return /*#__PURE__*/_react.default.createElement(_viewUser.ViewUser, rest);

        case _constants.CHANGE_PASSWORD_MODAL_KEY:
          return /*#__PURE__*/_react.default.createElement(_changePassword.ChangePassword, rest);

        case _constants2.CONFIRM_MODAL_KEY:
          return /*#__PURE__*/_react.default.createElement(_confirmModal.ConfirmModal, rest);

        case _constants3.CREATE_ROLE_MODAL_KEY:
          return /*#__PURE__*/_react.default.createElement(_createRole.CreateRole, rest);

        case _constants4.CREATE_CLIENT_MODAL_KEY:
          return /*#__PURE__*/_react.default.createElement(_createClient.CreateClient, rest);

        case _constants5.CREATE_API_MODAL_KEY:
          return /*#__PURE__*/_react.default.createElement(_createApi.CreateApi, rest);

        case _constants6.CREATE_SCOPE_MODAL_KEY:
          return /*#__PURE__*/_react.default.createElement(_createScope.CreateScope, rest);

        case _constants7.CREATE_TENANT_MODAL_KEY:
          return /*#__PURE__*/_react.default.createElement(_createTenant.CreateTenant, rest);

        default:
          return null;
      }
    }
  }]);
  return OAuthModals;
}(_react.PureComponent);

exports.OAuthModals = OAuthModals;
(0, _defineProperty2.default)(OAuthModals, "propTypes", {
  activeModal: _propTypes.default.string.isRequired
});
//# sourceMappingURL=oauth-modals.js.map